// Real data for Umoona Opal Mine & Museum from website

export const siteInfo = {
  name: "Umoona Opal Mine & Museum",
  tagline: "The largest single underground tourist attraction in Coober Pedy",
  description: "Umoona Opal Mine – first worked in the 1920s, today we take people through the mine to see (and understand) how opal is formed and mined.",
  phone: "(08) 8672 5288",
  email: "admin@umoonaopalmine.com.au",
  address: "14 Hutchison St, Coober Pedy SA 5723, Australia",
  hours: {
    general: "8:30am – 5:30pm",
    tours: "10am, 2pm, and 4pm daily (except Mondays & Fridays when only 4pm tour runs)",
    special: "Closed Christmas Day, 25h December 2024, and will reopen on 8th January 2025. Also seasonally closed for the entire month of February"
  },
  heroImage: "/assets/Umoona-MineTour-79521.jpg"
};

export const museum = {
  title: "Free Underground Museum",
  description: "Beautiful museum with history of the area, its people, fossils, and opals. Great display and lots of info on display with an underground cinema showing our award-winning movie.",
  features: [
    "History of Coober Pedy and its people",
    "Extensive fossil displays and specimens", 
    "Comprehensive opal formation exhibits",
    "Underground cinema showing 'Story of Opal'",
    "Original mining equipment displays",
    "Traditional Aboriginal cultural artifacts"
  ],
  hours: "8:30am – 5:30pm",
  admission: "FREE ENTRY",
  highlights: [
    {
      title: "Story of Opal Cinema",
      description: "Award-winning 20-minute documentary presented in underground theatre on three panoramic screens"
    },
    {
      title: "Mining Heritage", 
      description: "Discover authentic mining history from the 1920s with original equipment and techniques"
    },
    {
      title: "Fossil Collection",
      description: "View unique opalised fossils and geological specimens found in the region"
    }
  ],
  images: [
    "/assets/hgnt9n6h_Turbo360-1043175.jpg",
    "/assets/Turbo360-1043182.jpg",
    "/assets/z9aowyx7_Umoona2025-P1043722.jpg"
  ]
};

export const tours = {
  title: "Guided Underground Opal Mine Tours",
  description: "Umoona Opal Mine first worked in the 1920s… and today we take people through this Coober Pedy mine to see (and understand) how opal is formed and mined.",
  schedule: "10am, 2pm and 4pm Daily",
  scheduleException: "(EXCEPT MONDAYS & FRIDAYS when only the 4pm tour runs)",
  pricing: {
    adult: "$15.50",
    children: "$8.50",
    family: "from $36.00",
    groupRates: "Coach group rates available"
  },
  bookingInfo: "No online bookings. Tickets are available for purchase within our opal shop from 30 minutes prior to each tour. Please inquire with our friendly staff.",
  includes: [
    "'The Story of Opal' – 20 minute award-winning documentary in underground theatre on three panoramic screens",
    "Explanation of opals including different types and quality",
    "Underground dugout home – contrasting examples of early hand dug and modern machine dug dugouts",
    "Explanation of reasons and differences to living underground",
    "10% Discount on Jewellery not already discounted",
    "Complimentary Tea/Coffee after your tour"
  ],
  images: [
    "/assets/MarketingUmoona-PMAC8337-Enhanced-NR-1.jpg",
    "/assets/UMOONA-MineTour-PMAC7740.jpg",
    "/assets/UMOONA-MineTour-PMAC7752.jpg",
    "/assets/UMOONA-MineTour-PMAC7816.jpg",
    "/assets/Umoona-MineTour-7895.jpg",
    "/assets/bnnarbgj_Umoona2025-P1043722.jpg",
    "/assets/2022-1018518.jpg"
  ]
};

export const accommodation = {
  title: "Commercial Group Tours and Accommodation",
  description: "Umoona Opal Mine offers unique underground accommodation for groups big and small.",
  details: "We provide accommodation which consists of underground bunkhouses, 4 to 6 share. Each bunkhouse is of various size, and our largest has 102 beds.",
  features: [
    "Extremely comfortable for sleeping with temperatures maintaining a consistent 24°C degrees",
    "All rooms consist of bunk beds with mattresses",
    "Linen can be supplied if required", 
    "Toilet facilities provided for each group",
    "Fridge, sink, kettle, toaster available",
    "Water metered showers",
    "Extended and Custom Tours available for Groups"
  ],
  temperature: "24°C constant underground temperature",
  capacity: "Up to 102 beds in largest bunkhouse",
  contactInfo: "Contact for pricing and availability",
  suitableFor: [
    "School groups",
    "Tour groups", 
    "Large families",
    "Educational trips",
    "Adventure groups"
  ]
};

export const opalStore = {
  title: "Authentic Australian Opals",
  description: "Browse our collection of genuine Coober Pedy opals, from affordable specimens to investment-grade stones.",
  categories: [
    {
      name: "Rough Opals",
      description: "Uncut opal specimens perfect for collectors and hobbyists",
      priceRange: "$15 - $500"
    },
    {
      name: "Polished Stones",
      description: "Beautiful finished opals ready for jewelry or display", 
      priceRange: "$25 - $2,000"
    },
    {
      name: "Opal Jewelry",
      description: "Handcrafted jewelry featuring our finest opal stones",
      priceRange: "$85 - $5,000"
    },
    {
      name: "Fossils & Specimens",
      description: "Rare opalized fossils and unique geological specimens",
      priceRange: "$45 - $1,500"
    }
  ],
  features: [
    "Certificate of authenticity with every purchase",
    "Expert advice on opal quality and value",
    "Worldwide shipping available",
    "30-day satisfaction guarantee",
    "Custom jewelry design service"
  ],
  externalShopUrl: "https://example.com/opals"
};

export const webcams = {
  title: "Coober Pedy Webcams",
  description: "View LIVE Webcam and Timelapse video in the Outback town of Coober Pedy in South Australia. Live footage is captured on top of Umoona Opal Mine & Museum.",
  cameras: [
    {
      id: 1,
      name: "Hutchison Street",
      description: "Located on top of Umoona Opal Mine, Coober Pedy.",
      mode: "live",
      streamUrl: "/api/webcams/hutchison/playlist.m3u8",
      posterUrl: "/api/webcams/hutchison/snapshot.jpg",
      aspectRatio: "1200 / 536"
    },
    {
      id: 2,
      name: "Opal Fields Cam",
      description: "Looking out across the opal fields surrounding Coober Pedy.",
      mode: "snapshot",
      snapshotUrl: "/api/webcams/opalfields/snapshot.jpg",
      aspectRatio: "704 / 576"
    },
    {
      id: 3,
      name: "Channel 16 — Rooftop Lookout",
      description: "Umoona Opal Mine Rooftop Lookout, looking out over Coober Pedy.",
      mode: "snapshot",
      snapshotUrl: "/api/webcams/rooftop/snapshot.jpg",
      aspectRatio: "1408 / 1152"
    }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Manuela Kneubuhler",
    rating: 5,
    text: "Great display and lots of info on display. Cinema on site",
    source: "Google Reviews"
  },
  {
    id: 2, 
    name: "Cheryl O'Donnell",
    rating: 5,
    text: "Very informative, lived the tour, has some beautiful opal jewellery",
    source: "Google Reviews"
  },
  {
    id: 3,
    name: "rf1892",
    rating: 5,
    text: "Free entry. Good display.",
    source: "Google Reviews"
  },
  {
    id: 4,
    name: "Ayoma Dhanapala",
    rating: 5,
    text: "We visited Umoona as The Ghan train passengers yesterday, and had a lovely time with the guide. The lunch was delicious and bought a genuine pair of earings. All staff were friendly and helpful. Great place to visit when in Coober Pedy.",
    source: "Google Reviews"
  },
  {
    id: 5,
    name: "Daryl Scales",
    rating: 5,
    text: "Very informative! A brilliant tour lead by Zoe a local, a must in Coober Pedy",
    source: "Google Reviews"
  },
  {
    id: 6,
    name: "Liv Rainey-Smith",
    rating: 5,
    text: "Beautiful museum with history of the area, its people, fossils, and opals. Excellent shop as well, the jewelry ranged from very affordable up to jaw-dropping treasures. Great quality and prices.",
    source: "Google Reviews"
  }
];

export const faqs = [
  {
    question: "Is the museum really free?",
    answer: "Yes! Our underground museum is completely free to explore. We believe everyone should have access to Coober Pedy's fascinating history and culture."
  },
  {
    question: "How long should I plan for my visit?",
    answer: "Allow 2-3 hours minimum. The free museum takes about 45 minutes to explore, guided tours are approximately 60 minutes, and you'll want time to browse our opal collection."
  },
  {
    question: "Is it suitable for children?",
    answer: "Absolutely! Children love the underground experience. The museum is stroller-friendly and our tours are engaging for all ages (supervision required)."
  },
  {
    question: "What should I wear underground?",
    answer: "Comfortable closed-toe shoes are essential. The underground temperature is constant at 22-24°C, so light layers are perfect year-round."
  },
  {
    question: "Can I buy opals on-site?",
    answer: "Yes! We have an extensive collection of authentic Coober Pedy opals, from affordable specimens to investment pieces. All come with certificates of authenticity."
  },
  {
    question: "Do you offer group discounts?",
    answer: "Yes! Groups of 10+ receive discounted tour rates. School groups and tour operators qualify for special educational packages."
  }
];